import React, { useState } from 'react'
import { DropdownLink, SidebarLabel, SidebarLink } from './styled'
import { CaretRight } from '@phosphor-icons/react'

export const SubMenu = ({ item }) => {
  const [subnav, setSubnav] = useState(false)

  const showSubnav = () => setSubnav(!subnav)

  return (
    <>
      <SidebarLink to={item.path} onClick={item.subNav && showSubnav}>
        <div className="active">
          {item.icon}
          <SidebarLabel>{item.title}</SidebarLabel>
        </div>
        <div>{item.subNav ? <CaretRight size={26} /> : null}</div>
      </SidebarLink>
      {subnav &&
        item.subNav.map((item, index) => {
          return (
            <DropdownLink to={item.path} key={index}>
              {item.icon}
              <SidebarLabel>
                <ul>
                  <li>{item.title}</li>
                </ul>
              </SidebarLabel>
            </DropdownLink>
          )
        })}
    </>
  )
}
